import Vue from "vue";
import Router from "vue-router";
import { store } from "xijs";
Vue.use(Router);

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
const router = new Router({
  mode: 'history',
  routes: [
    {
      path: "/",
      name: "home",
      component: () => import("../view/home/home"),
      meta: {
        title: "小福猩创作平台"
      }
    },
    {
      path: "/login",
      name: "login",
      component: () => import("../view/login/login"),
      meta: {
        title: " "
      }
    },
    {
      path: "/discover",
      name: "Discover",
      component: () => import("../view/Discover/index"),
      meta: {
        requireAuth: true,
        title: "gif编辑器"
      }
    },
    {
      path: "/myDraft",
      name: "myDraft",
      component: () => import("../view/my/myDraft"),
      meta: {
        requireAuth: true,
        title: "小福猩创作平台_我的创作"
      }
    },
    {
      path: "/index",
      name: "index",
      component: () => import("../view/index"),
      meta: {
        requireAuth: true,
        title: "小福猩创作平台_创作"
      },
      children:[
        {
          path: "/gifeditor",
          name: "gifeditor",
          component: () => import("../view/gifEditor/EmojiEditor"),
          meta: {
            requireAuth: true,
            title: "小福猩创作平台_图片编辑"
          }
        },
        {
          path: "/aiCreate",
          name: "aiCreate",
          component: () => import("../view/aiCreate/aiCreate"),
          meta: {
            requireAuth: true,
            title: "小福猩创作平台_AI"
          }
        },
      ]
    }
    // {
    //   path: "/video",
    //   name: "video",
    //   component: () => import("../view/videoEditor/index"),
    //   meta: {
    //     title: "视频编辑器"
    //   }
    // }
  ]
});




router.beforeEach((to, from, next) => {
  document.title = to.matched[0].meta.title;
  if (to.meta.requireAuth) {
    // 判断该路由是否需要登录权限
    let { value } = store.get("kxccAI_token");
    if (value) {
      // 通过vuex state获取当前的token是否存在
      next();
    } else {
      next({
        path: "/",
        query: { redirect: to.fullPath } // 将跳转的路由path作为参数，登录成功后跳转到该路由
      });
    }
  } else {
    next();
  }
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js